import swal from 'sweetalert2'

var swalAlert = (function () {
  var alertHomeCustomStyle = function (background, showConfirmButton, complete) {
    alertCustomStyle('homeAlertClass', background, showConfirmButton, '完善资料', complete)
  }

  var alertNormalStyle = function (text) {
    swal(
      '哎呦……',
      text || '出错了！',
      'error'
    )
  }

  var alertWarningStyle = function (text, confirmButtonText, complete) {
    swal({
      title: '温馨提示',
      text: text,
      imageUrl: require('@c_static/img/alert_warning.png'),
      confirmButtonColor: '#147ce8',
      confirmButtonText: confirmButtonText,
      allowEnterKey: false,
      confirmButtonClass: 'warningConfirmButtonClass',
      cancelButtonClass: 'warningConfirmButtonClass'
      // imageClass: 'warningImgClass'
    }).then(function (x) {
      if (complete && x.dismiss === undefined) {
        complete()
      }
    })
  }
  /*
        待重写
    */
  var alertCustomStyle = function (customClass, background, showConfirmButton, confirmButtonText, complete) {
    swal({
      padding: 0,
      customClass: customClass,
      confirmButtonClass: 'homeCertificationBtn',
      background: background,
      showCloseButton: true,
      showConfirmButton: showConfirmButton,
      confirmButtonText: confirmButtonText,
      allowEnterKey: false
    }).then(function (x) {
      if (complete && x.dismiss === undefined) {
        complete()
      }
    })
  }

  var alertHomeRushSuccessStyle = function (complete,html) {

    swal({
      title: '领取成功',
      customClass: 'homeRushAlert',
      width: '80vw',
      html,
      confirmButtonText:
          '确定',
      imageUrl: require('@c_static/img/alert_success.png'),
      confirmButtonClass: 'appConfirmButtonClass',
      allowEnterKey: false
    }).then(function (x) {
      if (complete && x.dismiss === undefined) {
        complete()
      }
    })
  }

  var updateLocation = function (complete) {
    let html = "<div style='font-size: 1.2rem;margin-bottom: 1rem'>您的收货地址已过期！确认更新</div>"
    swal({
      title: '更新提示',
      customClass: 'homeRushAlert',
      width: '80vw',
      html,
      confirmButtonText: '确定',
      imageUrl: require('@c_static/img/alert_warning.png'),
      confirmButtonClass: 'appConfirmButtonClass',
      allowEnterKey: false
    }).then(function (x) {
      if (complete && x.dismiss === undefined) {
        complete()
      }
    })
  }

  var alertHomeRushFailStyle = function (faied, callback, title = '领取失败', imageUrl = require('@c_static/img/alert_warning.png')) {
    swal({
      title,
      customClass: 'homeRushAlert',
      text: faied,
      width: '80vw',
      imageUrl,
      confirmButtonColor: '#0068ff',
      confirmButtonText: '确定',
      confirmButtonClass: 'appConfirmButtonClass',
      allowEnterKey: false
    }).then(function (x) {
        	if (callback && x.dismiss === undefined) {
        callback()
      }
    })
  }

  var alertHomeRushWaitingStyle = function (text) {
    swal({
      title: '领取失败',
      customClass: 'homeRushAlert',
      width: '80vw',
      text: text,
      confirmButtonText:'确定',
      imageUrl: require('@c_static/img/alert_warning.png'),
      confirmButtonClass: 'appConfirmButtonClass',
      allowEnterKey: false
    })
  }

  // 验号违规号弹窗  写死的
  var alertHomeRushInconformityStyle = function (faied, callback, title = '不符合条件', imageUrl = require('@c_static/img/alert_error.png')) {
    swal({
      title,
      customClass: 'homeRushAlert',
      text: faied,
      width: '80vw',
      imageUrl,
      confirmButtonColor: '#0068ff',
      confirmButtonText: '关闭',
      confirmButtonClass: 'appConfirmButtonClass',
      allowEnterKey: false
    }).then(function (x) {
      if (callback && x.dismiss === undefined) {
        callback()
      }
    })
  }

  //订单驳回
  var alertRejectCustom = function (text,callback) {
    swal({
      title:"驳回订单",
      text: "描述：" + text,
      imageUrl: require('@c_static/img/alert_warning.png'),
      confirmButtonColor: '#0068ff',
      confirmButtonText: '前往查看',
      allowEnterKey: false,
      confirmButtonClass: 'appConfirmButtonClass',

    }).then(function (x) {
      if (callback && x.dismiss === undefined) {
        callback()
      }
    })
  }


  // 自定义展示内容
   	var alertCustom = function ({title, customClass = 'homeRushAlert', width = '80vw', text, html, showCloseButton = true, showConfirmButton = true, confirmButtonText = '确定', imageHeight = 60, imageUrl = require('@c_static/img/alert_warning.png'), confirmButtonClass = 'appConfirmButtonClass', allowEnterKey = false, background} = {}) {
   		return swal({
	   			title,
	   			customClass,
	   			width,
	   			text,
	   			html,
	   			showCloseButton,
	   			showConfirmButton,
	   			confirmButtonText,
	   			imageHeight,
	   			imageUrl,
	   			confirmButtonClass,
	   			allowEnterKey,
	   			background
   		})
   	}

  return {
    alertNormalStyle: alertNormalStyle,
    alertWarningStyle: alertWarningStyle,
    alertCustomStyle: alertCustomStyle,
    alertHomeCustomStyle: alertHomeCustomStyle,
    alertHomeRushSuccessStyle: alertHomeRushSuccessStyle,
    alertHomeRushFailStyle: alertHomeRushFailStyle,
    alertHomeRushInconformityStyle: alertHomeRushInconformityStyle,
    alertHomeRushWaitingStyle,
    alertCustom,
    updateLocation,
    alertRejectCustom
  }
})()
export default swalAlert



// WEBPACK FOOTER //
// ./src/utils/swalAlert.js